function hex2RgbComponents(hex) {
  if (!isHex(hex)) {
    throw new Error(`Invalid HEX to RGB conversion: ${hex}`);
  }
  let r;
  let g;
  let b;
  if (hex.length === 4) {
    r = "0x" + hex[1] + hex[1];
    g = "0x" + hex[2] + hex[2];
    b = "0x" + hex[3] + hex[3];
  } else if (hex.length === 7) {
    r = "0x" + hex[1] + hex[2];
    g = "0x" + hex[3] + hex[4];
    b = "0x" + hex[5] + hex[6];
  } else {
    r = "";
    g = "";
    b = "";
  }
  return `${Number(r)} ${Number(g)} ${Number(b)}`;
}
function isHex(color) {
  const format = /^#([\da-f]{3}){1,2}$/i;
  return format.test(color);
}
export {
  hex2RgbComponents
};
//# sourceMappingURL=colorTransforms.js.map
